<script>
  import Index from './pages/Index.svelte'
  export let featured = null;
</script>

<main>
  <Index />
</main>

